"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var button_1 = require("../../../button");
var form_1 = require("../../../form");
var style_1 = require("../style");
var InstanceForm = function (_a) {
    var onSubmit = _a.onSubmit, onSuccess = _a.onSuccess;
    var _b = react_1.useState(''), instanceName = _b[0], setInstanceName = _b[1];
    var _c = react_1.useState(false), error = _c[0], setError = _c[1];
    var handleChange = function (field) {
        if (typeof field.value === 'string') {
            setInstanceName(field.value);
        }
    };
    var handleSubmit = function (event) {
        event.preventDefault();
        onSubmit(instanceName)
            .then(onSuccess)["catch"](function (error) {
            setError(true);
        });
    };
    return (react_1["default"].createElement("form", { onSubmit: handleSubmit },
        error && (react_1["default"].createElement(style_1.Error, { role: "alert" }, "We could not find an instance with this name.")),
        react_1["default"].createElement(form_1.Wrapper, { label: "Instance", name: "instance" },
            react_1["default"].createElement(form_1.Input, { name: "instance", onChange: handleChange })),
        react_1["default"].createElement(button_1.Submit, { label: "Next" })));
};
exports["default"] = InstanceForm;
